<template>
    <div>
        <!-- <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.showType" placeholder="请选择展示状态">
                        <el-option value="" key="" label="所有状态"></el-option>
                        <el-option :value="1" :key="1" label="展示中"></el-option>
                        <el-option :value="0" :key="0" label="隐藏中"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                </el-col>
            </el-row>
        </div> -->
        <div v-if="$utils.have('/img/depot/create')" class="page-btns-box">
            <!-- <el-button
                type="primary"
                icon="el-icon-upload"
                @click="upload"
                >批量上传</el-button
            > -->
            <el-button
                type="primary"
                icon="el-icon-plus"
                @click="add"
                size="small"
                >新建图片</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-image class="img" :src="scope.row.imgUri" fit="cover"/>
                    </template>
                </el-table-column>
                <el-table-column prop="imgName" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.enable == 1" size="mini" type="success">启用</el-tag>
                        <el-tag v-else size="mini" type="info">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-if="type===1" label="规则">
                    <template slot-scope="scope">
                        <span v-if="scope.row.useRule === 0">随机</span>
                        <span v-if="scope.row.useRule === 1">固定</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="type===0" prop="modifyTime" label="最近更新时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/img/depot/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button>
                        <template v-if="$utils.have('/img/depot/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                icon="el-icon-delete"
                                @click="updateHanderEvent(scope.row)"
                                >删除</el-button>
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                icon="el-icon-view"
                                @click="updateHanderEvent(scope.row)"
                                >展示</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                hide-on-single-page
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <!-- <file-upload @update="getDataList" ref="fileUpload"></file-upload> -->
        <edit ref="dataEdit" :dataList="dataList" @update="getDataList"></edit>
    </div>
</template>
<script>
// import fileUpload from './components/fileUpload'
import Edit from './components/edit'
export default {
    components:{Edit},
    data() {
        return {
            data: null,
            dataList: [],
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0],
                showType:""
            },
            listLoading: true,
        };
    },
    mounted() {
        this.getDataList();
    },
    computed: {
        type() {
            return this.$route.name === 'imgDepot-background' ? 1 : 0
        }
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/img/depot/list",
                method: "POST",
                params: {...this.params, type: this.type},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params.pageNo = 1;
            this.params.showType = "";
            this.getDataList();
        },
        //标记状态
        updateHanderEvent(data){
            const status = data.status == 1 ? 0 : 1;
            const _msg = status == 1 ? '确定要展示该图片吗?' : '确定要删除该图片吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/img/depot/updateStatus",
                    method: "POST",
                    params: {id: data.id , status: status},
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            })
        },
        //上传
        // upload(){
        //     this.$refs.fileUpload.show();
        // },

        //新增事件
        add(){
            this.$refs.dataEdit.show({type: this.type});
        },
        //编辑事件
        edit(id) {
            this.$refs.dataEdit.show({id, type: this.type});
        }  
    },
};
</script>

<style lang="scss" scoped>
.img{
    max-width: 60px;
}
.ellipsis{
    max-width:100%;
}
</style>